import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  className = '',
  variant = 'primary',
  fullWidth = false
}) => {
  const {
    trackCustom
  } = useMetaPixel();
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackCustom('InitiateCheckoutClick', {
      buttonText: text
    });
    const checkoutSection = document.getElementById('checkout');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-full py-4 px-8 text-lg shadow-lg';
  const variants = {
    primary: 'bg-gradient-to-r from-orange-500 to-red-600 text-white hover:from-orange-600 hover:to-red-700 focus:ring-orange-500 shadow-orange-500/30',
    secondary: 'bg-white text-orange-600 border-2 border-orange-100 hover:bg-orange-50 focus:ring-orange-500'
  };
  return <button onClick={handleClick} className={`
        ${baseStyles}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-16">
      <span data-id="element-17">{text}</span>
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-18" />
    </button>;
};